import React, { useState } from "react";

import Paper from '@mui/material/Paper';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';

import PropTypes from 'prop-types';
import Login from "../components/login/Login";
import Signup from "../components/signup/Signup";
import { Toolbar, TextField, Button, Stack, Snackbar, Alert } from "@mui/material";
import { InvokeAPI } from "../apis/API";
import { getUserMgmtBase } from "../config/apiBase";
import { useParams } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from "react-router-dom";
import AsyncButton from "../components/common/AsyncButton";
import { useAsyncAction } from "../components/common/useAsyncAction";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const SetNewPassword = () => {
  const { id } = useParams()

  const navigate = useNavigate();


  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const [passwordData, setPasswordData] = React.useState({
    emailid: "",
    password: ""
  });
  const { run, loading: submitting } = useAsyncAction();

  const handleChange = (event) => {
    const { name, value } = event.target
    setPasswordData((prev) => ({ ...prev, [name]: value }))
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    await run(async () => {
      const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/password/new`,
        {
          "EmailId": passwordData.emailid,
          "Password": passwordData.password,
          "Code": id,
        },
        'POST',
        {},
        false)
      if (uinfo.iserror || uinfo.othererror) {
        setState({ open: true, severity: "error", message: "Unable to reset password. Please try again." })
      } else {
        setState({ open: true, severity: "success", message: "Your password has been reset, please login now" })
        setPasswordData({ emailid: "", password: "" })
      }
    });
  }

  const [state, setState] = useState({ open: false, message: "", severity: "" })

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [tabvalue, setTabvalue] = React.useState(0);

  return (
    <Grid2 spacing={2}>
      <Toolbar></Toolbar>
      <Grid2 display="flex" justifyContent="center" alignItems="center" size="grow" sx={{ marginTop: '50px' }}>
        <Paper 
          elevation={0}
          sx={{
            borderRadius: 4,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            maxWidth: 450,
            width: '100%',
            overflow: 'hidden',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            animation: 'fadeIn 0.5s ease-in',
            '@keyframes fadeIn': {
              from: { opacity: 0, transform: 'translateY(20px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={state.open}
            onClose={handleClose}
            key={state.message}
            autoHideDuration={6000}
            TransitionProps={{ timeout: 300 }}
          >
            <Alert 
              variant="filled" 
              severity={state.severity}
              sx={{
                animation: 'slideUp 0.3s ease-out',
                '@keyframes slideUp': {
                  from: {
                    opacity: 0,
                    transform: 'translateY(-20px)',
                  },
                  to: {
                    opacity: 1,
                    transform: 'translateY(0)',
                  },
                },
              }}
            >
              {state.message}
            </Alert>
          </Snackbar>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabvalue} centered>
              <Tab label="Reset Password" {...a11yProps(0)} />
            </Tabs>
          </Box>
                    <CustomTabPanel value={tabvalue} index={0}>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <TextField
                label="Email"
                variant="outlined"
                name="emailid"
                value={passwordData.emailid}
                onChange={handleChange}
                disabled={submitting}
                fullWidth
                required
                autoComplete="email"
                sx={{ 
                  mx: 2,
                  '& .MuiOutlinedInput-root': {
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-1px)',
                    },
                  },
                }}
              />
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <TextField
                type={showPassword ? 'text' : 'password'}
                label="Password"
                name="password"
                value={passwordData.password}
                onChange={handleChange}
                disabled={submitting}
                required
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={
                          showPassword ? 'hide the password' : 'display the password'
                        }
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                        disabled={submitting}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  mx: 2,
                  '& .MuiOutlinedInput-root': {
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-1px)',
                    },
                  },
                }}
              />
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <AsyncButton 
                type="submit" 
                variant="contained" 
                color="primary" 
                onClick={handleForgotPasswordSubmit}
                loading={submitting}
                fullWidth
                sx={{ 
                  mx: 2,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: (theme) => theme.shadows[8],
                  },
                }}
              >
                Reset Password
              </AsyncButton>
            </Box>
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
              <Button 
                sx={{ 
                  textTransform: "initial",
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateX(-4px)',
                  },
                }} 
                type="link" 
                color="primary" 
                onClick={(e) => { e.preventDefault(); navigate("/app") }}
              >
                <KeyboardArrowLeftIcon sx={{ mr: 0.5 }} />Back to Login page
              </Button>
            </Box>
            </CustomTabPanel>
        </Paper>
        <br />
      </Grid2>
    </Grid2>
  );
};

export default SetNewPassword;
